import { cloneDeep } from 'lodash/lang';

import { serializePhoneNumber } from '../../../../../../../../services/geo/e-164';
import { PAYMENT_TYPE_PHYSICAL } from '../../../../constants';
import { convertDobToDate } from '../AddOrEditPatientInfoModalService';

export default function prepareAddPatientInfo(info, ssu, medicalRecordNumber) {
  const patientInfo = cloneDeep(info);
  const { cardId, paymentType, phonesInfo, address, email, guardianPhone, ...restPatientInfo } = patientInfo;
  const { neverCallAgain, voicemailNotAllowed, preferredContactMethod, primary, alternative } = phonesInfo;

  const studyIdentifier = ssu.study.uniqueIdentifier;
  const studySiteIdentifier = ssu.site.uniqueIdentifier;
  const patientSourceId = ssu.source.id;
  const statusName = ssu.status.name;

  const { addressLine1, addressLine2, city, state, country, zipCode } = address;

  const primaryContact = serializePhoneNumber(primary.nationalNumber);
  const emergencyContact = serializePhoneNumber(alternative.nationalNumber);
  const guardianPhoneNumber = serializePhoneNumber(guardianPhone.nationalNumber);

  return {
    ...restPatientInfo,
    cardId,
    dob: convertDobToDate(info.dob),
    guardianDob: convertDobToDate(info.guardianDob),
    guardianPhone: guardianPhoneNumber || null,
    guardianPhoneCode: guardianPhoneNumber ? guardianPhone.countryId : null,
    paymentType: cardId && !paymentType ? PAYMENT_TYPE_PHYSICAL : paymentType,
    postalCode: zipCode,
    primaryContact,
    primaryPhoneCode: primaryContact && primary.countryId,
    primaryPhoneType: primary.phoneType,
    emergencyContact,
    alternativePhoneCode: emergencyContact && alternative.countryId,
    alternativePhoneType: alternative.phoneType,
    neverCallAgain,
    voicemailNotAllowed,
    preferredContactMethod,
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    studyIdentifier,
    studySiteIdentifier,
    patientSourceId,
    statusName,
    medicalRecordNumber,
    email: email || '',
    statusChangeLocation: 'ADD_PATIENT'
  };
}
